import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { GetAllSubsPackage } from '../../store/actions/new/subsPackageAction';
import { Link, useLocation } from 'react-router-dom';
import PaymentMethodModal from './popup/paymentMethodPopup';
import { ShimmerPostList } from "react-shimmer-effects";
const SubscriptionPackage = () => {
    const [isMonthly, setIsMonthly] = useState(true);
    const [productId, setProductId] = useState('');
    const [PrBtnPrice, setProductPrice] = useState('');
    const location = useLocation();

    const isActive = (path) => {
        return location.pathname === path ? 'active-section' : '';
    };
    const handleToggle = () => {
        setIsMonthly(prevState => !prevState);
    };
    //function to show popup
    const [openPopup, setPopup] = useState(false);
    const handlePaymentPopup = (productId, prPrice) => {
        setPopup(true);
        setProductId(productId);
        setProductPrice(prPrice);
    }
    // store data
    const { subscriptionPackage } = useSelector((store) => store);
    const { data, category, isLoading } = subscriptionPackage;
    const dispatch = useDispatch();
    useEffect(() => {
        if (!data || data.length === 0) {
            dispatch(GetAllSubsPackage());
        }
    }, [dispatch, data])

    return (
        <div>

            <div className="service-navigation">
                <div className="service-navigation-item">
                    <Link className={isActive('/user/store/subscriptions')} to="/user/store/subscriptions">Subscriptions</Link>
                </div>
                <div className="service-navigation-item">
                    <Link className={isActive('/user/store/services')} to="/user/store/services">Services</Link>
                </div>
            </div>
            <div className="card-container card-package-area">
                <div className="pricing-switch">
                    <label className={isMonthly ? "selected" : ""} htmlFor="pricing-switch">Monthly</label>
                    <label className="switch">
                        <input
                            id="pricing-switch"
                            type="checkbox"
                            checked={!isMonthly}
                            onChange={handleToggle}
                        />
                        <span className="slider round"></span>
                    </label>
                    <label className={!isMonthly ? "selected" : ""} htmlFor="pricing-switch">Yearly <span className="package-discount">Save 15%</span></label>
                </div>
                {isLoading && <ShimmerPostList postStyle="STYLE_FOUR" col={3} row={1} gap={30} />}
                {!isLoading && (
                    <div className="package-wrapper">
                        {(isMonthly ? (
                            <>
                                {data && data.length > 0 ? data
                                    .filter(item => {
                                        return item.renewalIntervalName === "Month" &&
                                            category.some(cat => cat.id === item.categoryID)

                                    })
                                    .slice(0, 3)
                                    .map((item) => {
                                        return (
                                            <div className="pricing-table" key={item.id}>
                                                <div className="pricing-plan">
                                                    <h4 className="pricing-title"><span className={item.title === 'Advance' ? "color-primary" : "color-secondary"}>{item.title}</span></h4>
                                                    <p>Upto {item.limitCard} cards</p>
                                                    <div className={item.title === 'Advance' ? "pricing-wrapper bg-br-primary text-white py-2" : "pricing-wrapper bg-br-secondary text-white py-2"}>
                                                        <sup>$</sup>
                                                        <span className="price">{item.price}</span>
                                                        <sub>/month</sub>
                                                    </div>
                                                </div>
                                                <ul className="features">
                                                    <li>5000 collection</li>
                                                    <li>Card Customization</li>
                                                    <li>Free Email Support</li>
                                                    <li>Security Suite</li>
                                                </ul>
                                                <Link onClick={() => { handlePaymentPopup(item.id, item.price) }} className={item.title === 'Advance' ? "btn bg-br-primary" : "btn btn-lightgreen"}>Get Started</Link>
                                            </div>
                                        )
                                    }) : (
                                    <div className="no-packages">
                                        <p>No subscription packages found</p>
                                    </div>
                                )}
                            </>
                        ) : (
                            <>
                                {data && data.length > 0 ? data
                                    .filter(item => {
                                        return item.renewalIntervalName === "Year" &&
                                            category.some(cat => cat.id === item.categoryID)

                                    })
                                    .slice(0, 3)
                                    .map((item) => {
                                        return (
                                            <div className="pricing-table" key={item.id}>
                                                <div className="pricing-plan">
                                                    <h4 className="pricing-title"><span className={item.title === 'Advance' ? "color-primary" : "color-secondary"}>{item.title}</span></h4>
                                                    <p>Upto {item.limitCard} cards</p>
                                                    <div className={item.title === 'Advance' ? "pricing-wrapper bg-br-primary text-white py-2" : "pricing-wrapper bg-br-secondary text-white py-2"}>
                                                        <sup>$</sup>
                                                        <span className="price">{item.price}</span>
                                                        <sub>/year</sub>
                                                    </div>
                                                </div>
                                                <ul className="features">
                                                    <li>5000 collection</li>
                                                    <li>Card Customization</li>
                                                    <li>Free Email Support</li>
                                                    <li>Security Suite</li>
                                                </ul>
                                                <Link onClick={() => { handlePaymentPopup(item.id, item.price) }} className={item.title === 'Advance' ? "btn bg-br-primary" : "btn btn-lightgreen"}>Get Started</Link>
                                            </div>
                                        )
                                    }) : (
                                    <div className="no-packages">
                                        <p>No subscription packages found</p>
                                    </div>
                                )}
                            </>
                        ))}
                    </div>
                )}
                <div className="more-packages">
                    <h3 className="section-title">Need more</h3>
                    <div className="more-pck-wrapper">
                        {data && data.length > 0 ? (
                            data.filter(item => {
                                return item.renewalIntervalName === (isMonthly ? "Month" : "Year") &&
                                    category.some(cat => cat.id === item.categoryID)

                            })
                                .slice(3) // Get items after the first 3
                                .map((item) => {
                                    return (
                                        <div className="mr-single-package" key={item.id}>
                                            <div className="mrp-details">
                                                <h4>{item.title}</h4>
                                                <span>Up to {item.limitCard} cards</span>
                                            </div>
                                            <div className="mrp-price">
                                                <span>$</span>{item.price} /{item.renewalIntervalName}
                                            </div>
                                            <Link onClick={() => { handlePaymentPopup(item.id, item.price) }} className="btn btn-upgrade">
                                                Get Started
                                            </Link>

                                        </div>
                                    )
                                })
                        ) : (
                            <div className="no-packages">
                                <p>No additional packages found</p>
                            </div>
                        )}

                    </div>
                </div>
            </div>
            <PaymentMethodModal openModal={openPopup} setOpen={setPopup} productId={productId} productPrice={PrBtnPrice} />
        </div>
    );
}

export default SubscriptionPackage;
